import { ResponsiveDialogProvider } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useJobportalOffersStore } from '@eliadmin/core/src/stores/jobportal-offers-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { CurriculumsSortButton } from './filter/curriculums-sort-button';
import { CurriculumsFilterButton } from './filter/curriculums-filter-button';
import { useJobportalCurriculumsStore } from '@eliadmin/core/src/stores/jobportal-curriculums-store';

export const curriculumSortOptions = [
  { label: 'Najstaršie', value: 'created_at:asc' },
  { label: 'Najnovšie', value: 'created_at:desc' },
];

export const JobportalCurriculumsHeader = () => {
  const { t } = useTranslations();
  const { setFilter, applyFilter, filter } = useJobportalCurriculumsStore();

  const handleFilterChange = (filter: {
    order: 'asc' | 'desc';
    orderBy: 'created_at' | 'salary' | 'distance';
  }) => {
    setFilter(filter);
    applyFilter(filter);
  };

  return (
    <div className="mb-8 flex flex-col gap-6">
      <h3 className="w-full text-3xl font-bold text-foreground md:block">{t('text1739')}</h3>
      <div className="hidden items-center justify-start gap-8 md:flex">
        {curriculumSortOptions.map((option, index) => (
          <p
            key={index}
            className={cn(
              'cursor-pointer text-base font-normal text-primary',
              filter.order === option.value.split(':')[1] &&
                filter.orderBy === option.value.split(':')[0]
                ? 'font-semibold'
                : '',
            )}
            onClick={() =>
              handleFilterChange({
                order: option.value.split(':')[1] as 'asc' | 'desc',
                orderBy: option.value.split(':')[0] as 'created_at' | 'salary' | 'distance',
              })
            }
          >
            {option.label.startsWith('text') ? t(option.label) : option.label}
          </p>
        ))}
      </div>
      <div className="flex flex-col md:hidden">
        <ResponsiveDialogProvider>
          <div className="flex gap-4">
            <CurriculumsSortButton />
            <CurriculumsFilterButton />
          </div>
        </ResponsiveDialogProvider>
      </div>
    </div>
  );
};
